export const firstCapitalize = (str) => {
  if (!str) return '';
  const word = `${str}`;
  const first = word.charAt(0);
  return first.toUpperCase() + word.substr(1).toLowerCase();
};
